import OAuth, { actions as OAuthActions } from '../../lib/redux-oauth2';
import Url from '../../lib/config';

OAuth({
    // url: 'http://localhost:8123',
    // token: '/v1/oauth/token',
    url: Url.host,
    token: Url.token,
    client_id: null,
    client_secret: null,
    providers: {
        sabre: '/v1/auth'
    }
});

export { OAuthActions };



// WEBPACK FOOTER //
// ./src/config/Authentication.js